import { useQuery } from '@apollo/client';
import AppraiserUnavailableDataMapper from '../../../mappers/AppraiserUnavailableDataMapper';
import GET_UNAVAILABLE_PERIODS_ASSIGNED_ATLS from '../../../queries/UnavailablePeriods/getUnavailablePeriodsForAssignedAtlsQuery';

export const useExcludedDateIntervals = (eventId, skip) => {
  const { data, loading, error } = useQuery(GET_UNAVAILABLE_PERIODS_ASSIGNED_ATLS, {
    variables: {
      eventId: eventId
    },
    skip: skip
  });
  const excludedDateIntervalsForAtl = AppraiserUnavailableDataMapper.toExcludedDateIntervals(
    data?.unavailablePeriodsForAssignedAtls || []
  );

  return {
    data: excludedDateIntervalsForAtl,
    error: error,
    loading: loading
  };
};
